import customAxios from "../serverCall";

const listCoinPackages = async (body) => {
  const response = await customAxios.post(
    `/admin/coins/packages/list`,
    body
  );

  return response;
};

const updateCoinPackage = async (body) => {
  const response = await customAxios.post(
    `/admin/coins/packages/update`,
    body
  );

  return response;
};

const createCoinPackage = async (body) => {
  const response = await customAxios.post(
    `/admin/coins/packages/create`,
    body
  );

  return response;
};

const deleteCoinPackage = async (body) => {
  const response = await customAxios.post(
    `/admin/coins/packages/delete`,
    body
  );

  return response;
};

const CoinPackagesService = {
  listCoinPackages,
  updateCoinPackage,
  createCoinPackage,
  deleteCoinPackage,
};

export default CoinPackagesService;

